import type { FC, RefObject } from 'react';

import type { MetadataField } from '@/model/Metadata.model';

import SpreadsheetV16 from '@/components/UI/SpreadSheet/SpreadsheetV16';
import type { SpreadsheetV16Settings } from '@/components/UI/SpreadSheet/SpreadsheetV16';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTableV16';
import type { SpreadSheetAddRowV16, SpreadSheetRowV16 } from '@/components/UI/SpreadSheet/SpreadsheetV16.model';
import { defaultMetadataToColumnSettingMapperV16 } from '@/support/hot-v16';

interface AddAnimalsTableV16Props {
  data: Array<Record<string, unknown>>;
  settings: SpreadsheetV16Settings;
  innerRef: RefObject<HotTableRef>;
  metadata: Array<MetadataField>;
  setMetadata: (metadata: Array<MetadataField>) => void;
  setInvalid: (invalid: boolean) => void;
  addRow: SpreadSheetAddRowV16;
  afterAddRow: () => void;
  defaultNewRowParams: Array<SpreadSheetRowV16>;
}

const AddAnimalsTableV16: FC<AddAnimalsTableV16Props> = ({
  data,
  settings,
  innerRef,
  metadata,
  setMetadata,
  setInvalid,
  addRow,
  afterAddRow,
  defaultNewRowParams,
}) => {
  return (
    <SpreadsheetV16
      className="pl4 pr4"
      testPrefix="add-animals-v16"
      data={data}
      innerRef={innerRef}
      settings={settings}
      metadata={metadata}
      setMetadata={setMetadata}
      setInvalid={setInvalid}
      metadataToColumnSettingMapper={defaultMetadataToColumnSettingMapperV16}
      addRow={addRow}
      afterAddRow={afterAddRow}
      defaultNewRowParams={defaultNewRowParams}
    />
  );
};

export default AddAnimalsTableV16;
